import React from "react";
import ReactDOM from "react-dom";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "react-quill/dist/quill.snow.css";
import "react-phone-number-input/style.css";
import "./index.css";
import App from "./containers/App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { configureStore, history } from "./store/configureStore";
import { PersistGate } from "redux-persist/integration/react";
import ScrollToTop from "./components/Helpers/ScrollToTop";
import { ConnectedRouter } from "connected-react-router";
import ErrorBoundary from "./containers/ErrorBoundary";
import axios from "axios";

// ROMI-1924 — cookie-session auth (BFF). The session lives in an httpOnly
// cookie sent automatically with every request; no bearer token in JS.
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
    Accept: `application/json`,
    "Content-Type": "application/x-www-form-urlencoded",
};

// ROMI-1924 — if the backend revokes access mid-session (front_access set to No,
// or account deactivated), bounce to the login page with the reason.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (
            error?.response?.status === 403 &&
            error?.response?.data?.code === "access_revoked" &&
            window.location.pathname !== "/login"
        ) {
            const msg = error.response.data.message || "You no longer have access to this application.";
            window.location.href = "/login?sso_error=" + encodeURIComponent(msg);
            return new Promise(() => {}); // navigating away — stop further handling
        }
        return Promise.reject(error);
    }
);

const { store, persistor } = configureStore();

const rootEl = document.getElementById("root");

function render() {
    ReactDOM.render(
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ConnectedRouter history={history}>
                    <ScrollToTop />
                    <ErrorBoundary>
                        <App />
                    </ErrorBoundary>
                </ConnectedRouter>
            </PersistGate>
        </Provider>,
        rootEl
    );
}

if (module.hot) {
    module.hot.accept("./containers/App", function () {
        setTimeout(render);
    });
}

render();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
